import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AdaptCommonChatAiModule } from "@common/lib/chat-ai/chat-ai.module";
import { ChatAiApplicationBarItem } from "@common/lib/chat-ai/chat-ai-application-bar-item/chat-ai-application-bar-item";
import { provideChatAiOrgProvider } from "@common/lib/chat-ai/chat-ai-org-provider.interface";
import { ChatAiSidebarTab } from "@common/lib/chat-ai/chat-ai-sidebar-tab";
import { AdaptCommonPagesModule } from "@common/lib/pages/pages.module";
import { provideApplicationBarItemType } from "@common/shell/application-bar/application-bar.component";
import { provideSidebarTab } from "@common/shell/common-sidebar/sidebar-tab";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { ChatAiOrgService } from "@org-common/lib/chat-ai-org-provider-impl/chat-ai-org.service";
import { AdaptDirectorySharedModule } from "@org-common/lib/directory-shared/directory-shared.module";
import { AdaptKanbanModule } from "@org-common/lib/kanban/kanban.module";
import { AdaptKanbanSharedModule } from "@org-common/lib/kanban/kanban-shared.module";
import { AdaptLabellingModule } from "@org-common/lib/labelling/labeling.module";
import { AdaptCommonMeetingsModule } from "@org-common/lib/meetings/common-meetings.module";
import { AdaptDisplayTreeObjectiveModule } from "@org-common/lib/objectives/display-tree-objective.component/display-tree-objective.module";
import { AdaptObjectivesSharedModule } from "@org-common/lib/objectives/objectives-shared.module";
import { AdaptOrgCommonPagesModule } from "@org-common/lib/pages/pages.module";
import { provideThemeTestPage } from "@org-common/lib/pages/theme-test/theme-test-page";
import { AdaptSurveyModule } from "@org-common/lib/survey/survey.module";
import { AdaptTeamDashboardSharedModule } from "@org-common/lib/teams/team-dashboard-shared/team-dashboard-shared.module";
import { AdaptZoneMapModule } from "@org-common/lib/zone-map/zone-map.module";
import { AdaptProcessMapSharedModule } from "app/features/architecture/process-map/process-map-shared.module";
import { AdaptRoleSharedModule } from "app/features/architecture/role/role-shared.module";
import { AdaptEmbedShellModule } from "app/services/layout/embed-shell.module";
import { DxDataGridModule } from "devextreme-angular/ui/data-grid";
import { CumulusComponentsPageComponent } from "./theme-test/cumulus-components-page/cumulus-components-page.component";
import { cumulusComponentsPageRoute } from "./theme-test/cumulus-components-page/cumulus-components-page.route";

@NgModule({
    declarations: [
        CumulusComponentsPageComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        AdaptCommonPagesModule,
        DxDataGridModule,
        AdaptTooltipModule,
        AdaptZoneMapModule,
        AdaptSurveyModule,
        AdaptDisplayTreeObjectiveModule,
        AdaptProcessMapSharedModule,
        AdaptRoleSharedModule,
        AdaptDirectorySharedModule,
        AdaptTeamDashboardSharedModule,
        AdaptEmbedShellModule,
        AdaptKanbanModule,
        AdaptKanbanSharedModule,
        AdaptObjectivesSharedModule,
        AdaptLabellingModule,
        AdaptCommonMeetingsModule,
        AdaptOrgCommonPagesModule,
        AdaptCommonChatAiModule,
    ],
    providers: [
        provideChatAiOrgProvider(ChatAiOrgService),
        provideSidebarTab(ChatAiSidebarTab),
        provideApplicationBarItemType(ChatAiApplicationBarItem),
        provideThemeTestPage({ route: cumulusComponentsPageRoute, title: "2c. Cumulus Components" }),
    ],
})
export class AdaptCumulusAboutModule {
    public static readonly Routes = [
        ...cumulusComponentsPageRoute.routes,
    ];
}
